/* eslint-disable no-nested-ternary */
import PropTypes from 'prop-types';
import { IconButton } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import moment from 'moment';
import _ from 'lodash';

import Router from 'next/router';

import { FadeInAnimation } from '../shared';


const BlogPostHeader = (props) => {

    const { title, published, tags } = props;    
    const publishedDate = _.toUpper(moment(published).format('DD MMMM YYYY'));

    const checkForTags = () => {
        return _.map(tags, (tag, index) => {
            const type = _.toUpper(_.get(tag, 'tag'));
            return <span className='blog-post-header-span' key={index}>{type}</span>;
        });
    };

    const onAllArticlesClick = () => {
        Router.push('/blog');
    };

    return (

        <div className='blog-post-header-parallax-wrapper'>

            <div className='container-root container-root-maxWidthLg blog-post-header-container'>

                <div className='blog-post-header-row'>

                    <IconButton onClick={onAllArticlesClick} color="inherit" className='blog-post-header-icon-button'>

                        <ArrowBack className='blog-post-header-arrow-back' />

                    </IconButton>

                    <p className='blog-post-header-paragraph'>All Articles</p>

                </div>

                <FadeInAnimation>

                    <h2 className='blog-post-header-header'>{title}</h2>

                    {checkForTags()}

                    <span className='blog-post-header-span'>{publishedDate}</span>

                </FadeInAnimation>

            </div>

        </div>
    );
};

export default BlogPostHeader;

BlogPostHeader.propTypes = {
    title: PropTypes.string,
    published: PropTypes.string,
    tags: PropTypes.array,
};

